import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.js';
import es from './es.js';
import ru from './ru.js';

/**
 * i18n с первого дня. Значительная часть американских дальнобойщиков —
 * не носители английского; добавлять переводы потом означает переписать
 * все строки. Плюс язык интерфейса вмораживается в запись осмотра:
 * документ обязан показывать, что человек прочитал.
 */
export const SUPPORTED_LOCALES = ['en', 'ru', 'es'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: 'English',
  ru: 'Русский',
  es: 'Español',
};

const STORAGE_KEY = 'pf.locale';

export function storedLocale(): SupportedLocale {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved !== null && (SUPPORTED_LOCALES as readonly string[]).includes(saved)) {
    return saved as SupportedLocale;
  }
  const browser = navigator.language.slice(0, 2);
  return (SUPPORTED_LOCALES as readonly string[]).includes(browser)
    ? (browser as SupportedLocale)
    : 'en';
}

export function setLocale(locale: SupportedLocale): void {
  localStorage.setItem(STORAGE_KEY, locale);
  void i18next.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export function currentLocale(): SupportedLocale {
  const lang = i18next.language.slice(0, 2);
  return (SUPPORTED_LOCALES as readonly string[]).includes(lang)
    ? (lang as SupportedLocale)
    : 'en';
}

void i18next.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru }, es: { translation: es } },
  lng: storedLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

document.documentElement.lang = storedLocale();

export default i18next;
